<template>
  <iframe
    :key="iframeSrc"
    :src="iframeSrc"
    width="100%"
    height="99%"
    style="border: none"
  ></iframe>
</template>

<script>
import { mapState } from 'vuex'

/** 嵌入 teaching-dev（专业成果等）；子应用需自行根据记录类型打开「成果一/二」表单并统一列表与详情的日期字段。 */
export default {
  computed: {
    ...mapState(['userInfo']),
    userId() {
      // 优先从 userInfo 拿，没有就从 localStorage 拿
      return this.userInfo?.userId || localStorage.getItem('standardUserId') || ''
    },
    iframeSrc() {
      const base = 'https://hyx.xueduoduo.com/teaching-dev/'
      const params = new URLSearchParams({
        userId: String(this.userId || ''),
        menuType: 'result',
        // 供 teaching-dev 读取：与父应用路由对齐（若子应用支持可避免「成果二」误开成果一表单）
        parentRouteName: String(this.$route.name || ''),
        parentFullPath: String(this.$route.fullPath || '')
      })
      return `${base}?${params.toString()}`
    }
  }
}
</script>



